import { type InputCreateConnectionRequest, type LensCompoundId } from "../../../gql-generated/types";

import { Connection } from "./Connection";
import { RangeModifierOperations } from "./RangeModifierOperations";

export class LensConnection extends Connection {
    readonly groupId: string | null = null;
}

export const LensConnectionOperations = {
    toVariables(
        organizationId: string,
        lensCompoundId: LensCompoundId,
        { groupId, priority, scheduleRange, vendorData }: LensConnection,
    ): InputCreateConnectionRequest {
        return {
            lensCompoundId,
            groupId,
            organizationId,
            priority,
            schedule: RangeModifierOperations.toSchedule(scheduleRange),
            vendorData: vendorData.map(({ key, value }) => ({
                key,
                value,
            })),
        };
    },
};
